import { Button, IconButton, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { messageError } from '../../../../../../store/batchTicket/constants';
import { mapCaptions } from '../../../../utils';
import { CustomerItemTagObject } from '../../../../utils/types';
import { ItemTag } from '../../../Customer/components/ItemTag';

import { RequiredAttentionResponsiveItem } from '.';

export const RequiredAttentionItemDesktop: React.FC<RequiredAttentionResponsiveItem> = ({
  handleDetailsCustomer,
  sectionIsOpened,
  toggleSection,
  detailsButtonIsDisabled,
  item,
}) => {
  return (
    <Shadow borderRadius={BoxRadius.xs} level={2}>
      <VStack
        p={Spacing['inline.xxs']}
        space={Spacing['inline.xxs']}
        alignItems="center"
        borderRadius={BoxRadius.xs}>
        <HStack w={'full'} justifyContent="space-between" alignItems={'center'}>
          <HStack space={Spacing['inline.md']} justifyContent="space-between" alignItems={'center'}>
            <VStack space={Spacing['stack.quarck']} maxW={'300px'}>
              <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
                Nome
              </Text>
              <Text
                noOfLines={2}
                width="200px"
                fontSize={Typography['fontsize.md']}
                color="neutral.darkest">
                {item?.customer?.customerName || messageError}
              </Text>
              <HStack space={Spacing['inline.nano']} alignItems="center">
                <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                  Conta
                </Text>
                <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                  {item?.customer?.account?.accountNumber || messageError}
                </Text>
                <TableContentItemCaptions forceDesktop icons={mapCaptions(item?.customer)} />
              </HStack>
            </VStack>
            <VStack space={Spacing['stack.quarck']}>
              <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
                Suitability
              </Text>
              <TableContentItemBadge>
                {item?.customer?.suitabilityProfileName || messageError}
              </TableContentItemBadge>
            </VStack>
            <VStack space={Spacing['stack.quarck']} w="120px">
              <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
                Hashtag
              </Text>
              <ItemTag
                isListing
                data={(item?.customer?.hashtags as unknown as CustomerItemTagObject[]) || []}
                itemId={item?.customer?.customerId}
              />
            </VStack>
          </HStack>
          <Button
            variant="textLink"
            onPress={handleDetailsCustomer}
            isDisabled={detailsButtonIsDisabled}
            _text={{
              fontFamily: Typography['fontfamily.base.semibold'],
              color: detailsButtonIsDisabled ? 'neutral.darkest' : 'brand.tertiary.principal',
            }}>
            Ver Detalhes
          </Button>
        </HStack>
        {item?.errors && item?.errors.length > 0 && (
          <VStack
            borderRadius={BoxRadius.sm}
            backgroundColor={Utils.ColorToken.WithOpacity('background', 'opacity.semiopaque')}
            space={Spacing['stack.xxxs']}
            px={Spacing['inline.xxs']}
            w={'full'}
            py={Spacing['inline.xxxs']}>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text fontSize={Typography['fontsize.md']} color="neutral.darkest" variant="semibold">
                Itens que Requerem atenção
              </Text>
              <IconButton
                icon={sectionIsOpened ? 'ChevronUp' : 'ChevronDown'}
                testId="section-toggle"
                onPress={toggleSection}
                iconColor={Color['neutral.black']}
              />
            </HStack>
            {sectionIsOpened && (
              <VStack space={Spacing['inline.xxxs']}>
                <Box h="1px" w={'full'} bg={'neutral.lightest'} />
                {item.errors?.map((error) => (
                  <HStack
                    key={error?.errorId}
                    justifyContent={'space-between'}
                    space={Spacing['inline.xs']}>
                    <Text
                      fontSize={Typography['fontsize.md']}
                      color="neutral.darkest"
                      flex={0.2}
                      variant="semibold">
                      {error?.errorTitle || messageError}
                    </Text>
                    <Text
                      flex={1}
                      fontSize={Typography['fontsize.md']}
                      color="neutral.darkest"
                      variant="regular"
                      textAlign="end">
                      {error?.errorMessage && error?.errorSuggest
                        ? `${error?.errorMessage} ${error?.errorSuggest}`
                        : messageError}
                    </Text>
                  </HStack>
                ))}
              </VStack>
            )}
          </VStack>
        )}
      </VStack>
    </Shadow>
  );
};
